<template>
  <v-container fluid>
    <v-layout row>
      <Header title="Obchodné podmienky" subtitle="www.duris.info" />
    </v-layout>
    <v-layout row wrap align-center justify-center fill-height class="pt-5">
      <v-flex xs12 sm6 md6 lg6>
        <!-- <h1 align="center">OBCHODNÉ PODMIENKY A REKLAMAČNÝ PORIADOK</h1> -->
        <p>
          <b>Zmluvný vzťah:</b>
        </p>
        <p>
          Vyplnením a doručením záväznej objednávky osobne, faxom, mailom, zaslaním
          internetovej objednávky, prípadne osobitnou kúpnou zmluvou a jej následným
          potvrdením od zamestnanca spoločnosti Ing. PaedDr. Vladimír Ďuriš / d'alej
          len "predávajúci", vzniká medzi predávajúcim a kupujúcim zmluvný vzťah
          podľa § 409 o kúpnej zmluve Obchodného zákonníka /zákon č.513/91 Zb. v
          znení neskorších predpisov), kde sa predávajúci zaväzuje dodať objednaný
          tovar a kupujúci ho prevziať a zaplatiť predávajúcemu kúpnu cenu.
        </p>
        <p>
          Pri každej objednávke musí spotrebiteľ uviesť meno a priezvisko, dodaciu a
          fakturačnú adresu, telefónne e-mail; fyzická a právnická osoba podnikateľ
          aj IČO, DIČ, IČ DPH. Tieto údaje budú v zmysle zákona o ochrane osobných
          údajov č. 428/2002 Z.z. použité iba v rámci obchodného vzťahu medzi
          predávajúcim a kupujúcim a nebudú poskytnuté tretej osobe (s výnimkou osoby
          zabezpečujúcej prepravu tovaru).
        </p>
        <p>
          <b>Platobné podmienky:</b>
        </p>
        <p>
          Záväzné akceptovanie objednávky nastane po overení dostupnosti, terminu
          dodania tovaru, resp. prípadnej zálohovej platby požadovanej predávajúcim.
          V Predávajúci je oprávnený aj v prípade objednávky tovaru zhotoveného podľa
          osobitných požiadaviek kupujúceho vyžiadať od kupujúceho zálohu v
          dohodnutej výške. Kupujúci v takomto prípade nemôže odstúpiť od uzavretej
          zmluvy. Kupujúci sa zaväzuje zaplatiť predávajúcemu zmluvnú pokutu vo výške
          poskytnutej zálohy za bezdôvodné neprevzatie tovaru zhotoveného podľa
          osobitných požiadaviek kupujúceho. Platba bude uskutočnená v hotovosti pri
          prevzatí objednaného tovaru, príp. faktúrou alebo dobierkou.
        </p>
        <p>
          <b>Zrušenie objednávky:</b>
        </p>
        <p>
          Kupujúci má právo stornovať objednávku bez poplatku, a to iba v deň
          zaslania záväznej akceptácie objednávky predávajúcim a to v prípade, že
          tovar ešte nebol predávajúcim vyrobený kupujúcemu. Objednávku je možné
          stornovať iba písomnou formou (emailom alebo poštou). Potvrdenie
          stornovania objednávky oznámi predávajúci kupujúcemu písomnou formou
          (emailom alebo poštou). Predávajúci môže upraviť možnosť stornovať
          objednávku podľa svojho uváženia, pokiaľ je to výhodnejšie pre kupujúceho v
          porovnaní so znením v tomto bode.
        </p>
        <p>
          <b>Práva a povinnosti zmluvných strán:</b>
        </p>
        <p>
          Predávajúci je povinný dodať na základe záväznej akceptácie objednávky
          kupujúcemu tovar v dohodnutom množstve, kvalite a termine a zabaliť ho
          alebo vybaviť na prepravu spôsobom potrebným na jeho uchovanie a ochranu.
          Predávajúci má právo na riadne a včasné zaplatenie kúpnej ceny od
          kupujúceho za dodaný tovar. Kupujúci je povinný prevziat zakup objednaný
          tovar, zaplatiť predávajúcemu dohodnutú kúpnu cenu v dohodnutej mene
          vrátane nákladov na doručenie tovaru, nepoškodzovať dobré obchodné meno
          predávajúceho. Kupujúci má právo na dodanie v množstve, kvalite, termine a
          mieste dohodnutom zmluvnými stranami.
        </p>
        <p>
          <b>Dodacie podmienky:</b>
        </p>
        <p>
          Dodávky objednaného tovaru kupujúcim budú realizované v čo najkratšom
          termíne, podľa dohody s predávajúcim. Po skompletizovaní Vašej objednávky
          Vás informujeme, kedy si môžete vyzdvihnúť Váš objednaný tovar na našej
          adrese počas otváracích hodín. Kupujúci je povinný prevziať tovar v sídle
          firmy Ďuriš, pokiaľ sa predávajúci s kupujúcim nedohodnú inak. V prípade,
          ak hrozí omeškanie dodania tovaru v dôsledku nepredvídateľných okolností
          nezavinených dodávateľom (napr. živelné udalosti, nedodržanie lehoty
          dodávky od výrobcu, zahraničného dodávateľa, oneskorenie alebo zlyhanie
          dopravy a pod.), je dodávateľ povinný bezodkladne informovať kupujúceho o
          tejto skutočnosti a dohodnúť s ním náhradnú (predsženú) lehotu dodania
          tovaru. Vlastnícke právo k tovaru prechádza na kupujúceho zaplatením kúpnej
          sumy v plnej výške. Platba bude uskutočnená v hotovosti pri prevzatí
          objednaného tovaru, príp. faktúrou. . Kupujúci je povinný skontrolovať
          tovar hneď po prevzatí. V prípade zistenia poškodenia tovaru je povinný
          kupujúci vyhotoviť záznam - reklamáciu o rozsahu a povahe poškodenia
          tovaru.
        </p>
        <p>
          <b>Odstúpenie od zmluvy:</b>
        </p>
        <p>
          Kupujúci je oprávnený stornovať objednávku bez uvedenia dovodu a to iba v 1
          deň kontaktovania predávajúceho so spotrebiteľom, t.j. v deň kedy
          objednávku predávajúci potvrdí kupujúcemu. Objednávku je možné stornovať
          výlučne písomnou formou (e-mailom, faxom), resp.oznámiť
          telefonicky.Predávajúci má právo zrušiť objednávku, alebo jej časť, ak sa
          tovar nevyrába , alebo nedodáva, alebo sa výrazne zmenila cena objednaného
          tovaru. Ak takáto situácia nastane, je predávajúci povinný kontaktovať
          kupujúceho za účelom dohodnutia a odsúhlasenia ďalšieho postupu. V prípade,
          ak kupujúci odstúpi od kúpnej zmluvy pred zaplatením celej kúpnej ceny,
          zmluvné strany sa dohodli, že zaplatená záloha na kúpnu cenu sa započíta v
          celej výške na zmluvnú pokutu, ktorú je povinný kupujúci zaplatiť
          predávajúcemu. Kúpna cena je splatná ihneď. V prípade neuhradenia kúpnej
          ceny do dňa splatnosti, má predávajúci právo uplatniť úrok z meškania vo
          výške 0,05% z dlžnej sumy za každý deň omeškania s platbou.
        </p>
        <p>
          <b>Záruka:</b>
        </p>
        <p>
          Spotrebiteľ obdrží k nákupu daňový doklad, ktorý slúži zároveň ako záručný
          list. Vo všeobecnosti je záručná doba pre plnenie spotrebiteľských zmlúv
          stanovená na minimálne 24 mesiacov. Reklamovať je možné len produkt
          zakúpený a zaplatený u predávajúceho. Pri uplatnení reklamácie je
          spotrebiteľ povinný doručiť (pokiaľ to charakter produktu umožňuje - nie
          zabudovaný produkt) reklamovaný produkt čistý, mechanicky nepoškodený,
          vrátane faktúry alebo iného dokladu o zaplatení produktu predávajúcemu.
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Header from "@/components/widgets/Header";
export default {
  name: "TermsAndConditions",
  components: {
    Header
  }
};
</script>

<style>
</style>